import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { toast } from 'sonner';
import { Monitor, Copy, Mail, MessageCircle } from 'lucide-react';

const enc = encodeURIComponent;

export const PcInstallBox = ({ t }) => {
  const url = window.location.origin;
  const [qr, setQr] = useState(null);
  useEffect(() => { QRCode.toDataURL(url, { width: 360, margin: 2 }).then(setQr); }, [url]);
  const steps = [t.pcI1, t.pcI2, t.pcI3, t.pcI4];
  const msg = `${t.pcITitle}: ${url}\n\n${steps.map((s, i) => `${i + 1}. ${s}`).join('\n')}`;
  const copy = async () => { try { await navigator.clipboard.writeText(msg); toast.success(t.shCopied); } catch { window.prompt('', msg); } };
  return (
    <div className="sh-play sh-pc" data-testid="share-pc-box">
      <b><Monitor size={16} /> {t.pcITitle}</b>
      {qr && <img className="sh-qr" src={qr} alt="QR PC" data-testid="share-pc-qr-img" />}
      <small className="mono sh-link" data-testid="share-pc-link">{url}</small>
      <ol className="sh-pc-steps" data-testid="share-pc-steps">{steps.map((s) => <li key={s}>{s}</li>)}</ol>
      <div className="row">
        <button className="btn btn-outline btn-sm" data-testid="share-pc-copy-btn" onClick={copy}><Copy size={14} /> {t.shCopy}</button>
        <a className="btn btn-share btn-sm" data-testid="share-pc-whatsapp-btn" target="_blank" rel="noreferrer" href={`https://wa.me/?text=${enc(msg)}`}><MessageCircle size={14} /> WhatsApp</a>
        <a className="btn btn-outline btn-sm" data-testid="share-pc-email-btn" href={`mailto:?subject=${enc(t.pcITitle)}&body=${enc(msg)}`}><Mail size={14} /> E-Mail</a>
      </div>
    </div>
  );
};
